module.exports = __webpack_public_path__ + "img/analysis_subjective_share_white.502f2eff.svg";